import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <h1>您是什麼身份？</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            
            <CardItem 
              src='images/card-img-1.jpg'
              text='主動發案讓廠商完成你想要的需求'
              label='顧客端'
              path='/products'
           />
           <CardItem 
              src='images/card-img-2.jpg'
              text='在這裡面尋找許多顧客第一線需求'
              label='廠商端'
              path='/products'
            />
          </ul>
          
        </div>
      </div>
    </div>
  );
}

export default Cards;
